// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__vTdHi","subContainer":"ChangePassword_subContainer__k8SLu","leftArrow":"ChangePassword_leftArrow__rjH3q"};